import {useContext} from 'react';
import {AuthContext} from './context';

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function useAuthStatus():
  'authenticated' | 'unauthenticated' | 'loading' | 'idle' | 'error' {
  const {status} = useAuth();
  return status;
}
